
import {
    NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';

import { ModalComponent } from './modal.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PortalModule,
    ],
    exports: [
        ModalComponent,
    ],
    declarations: [
        ModalComponent,
    ],
})
export class ModalModule {
    public static forRoot() {
        return {
            ngModule: ModalModule,
        };
    }
}
